/* eslint-disable @typescript-eslint/no-explicit-any */
import { GlobalState } from "common/global";
import ModelHelper from "../model/model.helper";
import * as Communicator from "@ts3d-hoops/web-viewer";

export default class CZoomOperator extends Communicator.Operators.Camera
    .CameraZoomOperator {
    private inShift = false;
    private _initMousePos: Communicator.Point2 = new Communicator.Point2(0, 0);
    private zoomSpeedFactor = 1;
    constructor(viewer: Communicator.IWebViewer) {
        super(viewer, viewer.view);
        this._viewer = viewer;
        setTimeout(() => {
            this.clearMapping();
            this.setMapping(
                Communicator.Button.Right,
                Communicator.KeyModifiers.Shift
            );
        }, 100);
    }
    onMousewheel(
        event: Communicator.Event.MouseWheelInputEvent
    ): Promise<void> {
        if (event.getEventType() !== Communicator.MouseInputType.Down) {
            if (event.getWheelDelta() > 0) {
                ModelHelper.setCursorViewer(this._viewer, "zoom-in");
            } else {
                ModelHelper.setCursorViewer(this._viewer, "zoom-out");
            }
            setTimeout(() => {
                const currPrimaryOperator = GlobalState.primaryOperator.get(
                    this._viewer
                );
                const cursor = GlobalState.mapOperatorCursor.get(
                    currPrimaryOperator ?? "select"
                );
                ModelHelper.setCursorViewer(this._viewer, cursor ?? "");
            }, 250);
        }
        // super.onMousewheel(event);
        this.mouseWheelExt(event);

        return Promise.resolve();
    }
    private getSpeed(): number {
        let speed = 1;
        if (this.zoomSpeedFactor > 0) {
            speed = 1 + this.zoomSpeedFactor * 0.2;
        } else if (this.zoomSpeedFactor < 0) {
            speed = 1 - Math.abs(this.zoomSpeedFactor) * 0.09;
        }
        return speed;
    }

    private async mouseWheelExt(
        event: Communicator.Event.MouseWheelInputEvent
    ): Promise<void> {
        // eslint-disable-next-line no-underscore-dangle
        const self = this as any;
        const delta =
            self._mouseWheelZoomDelta *
            self._mouseWheelZoomFactor *
            event.getWheelDelta() *
            this.getSpeed();
        if (self._dollyZoomEnabled) {
            await self._dollyZoom(-delta, undefined, event.getPosition());
        } else {
            await self._doZoom(delta, undefined, event.getPosition());
        }
        return Promise.resolve();
    }
    onMouseDown(event: Communicator.Event.MouseInputEvent): void {
        this._initMousePos = event.getPosition();
        super.onMouseDown(event);
    }
    onMouseMove(event: Communicator.Event.MouseInputEvent): Promise<void> {
        if (
            event.shiftDown() &&
            event.getButtons() === Communicator.Buttons.Right
        ) {
            const currMousePos = event.getPosition();
            if (currMousePos.x > this._initMousePos.x) {
                ModelHelper.setCursorViewer(this._viewer, "zoom-in");
            } else ModelHelper.setCursorViewer(this._viewer, "zoom-out");
            this._initMousePos = currMousePos;
        }
        return super.onMouseMove(event);
    }
    onMouseUp(event: Communicator.Event.MouseInputEvent): void {
        if (GlobalState.markupMode === "viewMode") {
            const currPrimaryOperator = GlobalState.primaryOperator.get(
                this._viewer
            );
            const cursor = GlobalState.mapOperatorCursor.get(
                currPrimaryOperator ?? "select"
            );
            ModelHelper.setCursorViewer(this._viewer, cursor ?? "");
            super.onMouseUp(event);
        }
    }

    getZoomSpeedFactor(): number {
        return this.zoomSpeedFactor;
    }

    setZoomSpeedFactor(value: number): void {
        if (value !== null && value !== undefined) {
            this.zoomSpeedFactor = value;
        }
    }
}
